import { render, staticRenderFns } from "./ProductPool.vue?vue&type=template&id=07cf4251&"
import script from "./ProductPool.vue?vue&type=script&lang=js&"
export * from "./ProductPool.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports